import { Injectable } from '@angular/core';
import { CanActivateChild } from '@angular/router';
import {ContextService} from "./context.service";
import {NavigationConfirmService} from "./navigation-confirm.service";


@Injectable({ providedIn: 'root' })
export class NavCheckService implements CanActivateChild {
  contextService:ContextService;
  navigationConfirmService:NavigationConfirmService;

  constructor(contextService:ContextService, navigationConfirmService:NavigationConfirmService) {
    this.contextService = contextService;
    this.navigationConfirmService = navigationConfirmService;

    //Prevent browser close
    window.addEventListener('beforeunload', (event) => {
      if (contextService.isModificationPending()) {
        event.preventDefault();
        event.returnValue = '';
      }
    });
  }

  canActivateChild() {
    if (this.contextService.isModificationPending()) {
      return this.navigationConfirmService.confirmModal$();
    }
    else {
      return true;
    }
  }
}
